import { createModule } from "redux-mvc";
import { initSaga } from "./saga";

const module = createModule({
  namespace: "GlobalPusher",
  iniState: {},
  reducer: state => state,
  sagas: [initSaga]
});

export default module;
